import { render, staticRenderFns } from "./BestPriceGoTo.vue?vue&type=template&id=55fe3258&scoped=true"
import script from "./BestPriceGoTo.vue?vue&type=script&lang=ts"
export * from "./BestPriceGoTo.vue?vue&type=script&lang=ts"
import style0 from "./BestPriceGoTo.vue?vue&type=style&index=0&id=55fe3258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fe3258",
  null
  
)

export default component.exports